import { api } from "@/api";

export type BalanceOperation = "add" | "remove";

interface UpdateSubDealerBalancePayload {
  userIds: number[];
  operation: BalanceOperation;
  amount: number;
}

export async function updateSubDealerBalance(
  payload: UpdateSubDealerBalancePayload
): Promise<{ success: boolean }> {
  await Promise.all(
    payload.userIds.map((subDealerId) =>
      api.client.patch(`/sub-dealers-new/${subDealerId}/balance`, {
        operation: payload.operation,
        amount: payload.amount,
      })
    )
  );
  return { success: true };
}
